import TagId from '~/constants/TagId';

export enum Dismissed {
  None = 0,
  Banner = 1
}

export enum PromoBanners {
  Earth,
  Ev,
  PriceDrop
}

export const NewPriceFilter = { tagIds: [TagId.PriceDrop.toString()] };
export const EarthDayFilter = { fuelTypes: ['Electric', 'Plug-In Hybrid'] };
